import { DYAD_ICON, TRIAD_ICON, INDIVIDUAL_ICON, FOCUS_GROUP_ICON } from "../utills/icons";

export const SCREENER_DRAFT = 0;
export const SCREENER_ACTIVE = 1;

export const QUESTION_CATEGORY_RADIO = 0;
export const QUESTION_CATEGORY_GROUP = 2;
export const QUESTION_CATEGORY_CHECKBOX = 1;

export const USE_OTHER_OPTION_NO = false;
export const USE_OTHER_OPTION_YES = true;

export const RESULT_FAIL = 0;
export const RESULT_PASS = 1;

export const OP_OR = "or";
export const OP_AND = "and";
export const OP_EQUALS = "e";
export const OP_NOT_EQUALS = "ne";
export const OP_ALWAYS = "always";
export const TYPE_QUESTION = "question";
export const TYPE_OPTION = "option";

export const OPTION_TYPE = { MUST: "must", MAY: "maybe", REJECT: "reject" };

export const LOGIC_ACTION_JUMP = "jump";
export const LOGIC_DETAILS_TYPE_TASK = "task";
export const LOGIC_DETAILS_TYPE_END_OF_TEST = "end_of_test";
export const LOGIC_DETAILS_TYPE_NEXT_TASK = "next_task";

export const TEST_DEVICE_TYPE_DESKTOP = "1"; // Desktop

export const ANALYSIS_TYPE_VIDEO_CLIP = "0";
export const ANALYSIS_TYPE_NOTES = "1";
export const ANALYSIS_TYPE_BOOKMARKS = "2";
export const ANALYSIS_TYPE_ANNOTATIONS = "3";
export const ANALYSIS_TYPE_TRANSCRIPTS = "4";
export const ANALYSIS_TYPE_TRANSLATION = "5";

export const ANALYSIS_TYPE_VIDEO_CLIP_TEXT = "Clip";
export const ANALYSIS_TYPE_NOTES_TEXT = "Note";
export const ANALYSIS_TYPE_BOOKMARKS_TEXT = "Bookmark";
export const ANALYSIS_TYPE_ANNOTATIONS_TEXT = "Annotation";
export const ANALYSIS_TYPE_TRANSCRIPTS_TEXT = "Transcription";
export const ANALYSIS_TYPE_TRANSLATION_TEXT = "Translation";

export const FILTER_SPACE_BY_RESPONDENT_SESSION = "FILTER_SPACE_BY_RESPONDENT_SESSION";
export const FILTER_SPACE_BY_SEARCH_KEYWORDS = "FILTER_SPACE_BY_SEARCH_KEYWORDS";
export const FILTER_SPACE_BY_TAGS = "FILTER_SPACE_BY_TAGS";

export const REEL_INITIAL = 0;
export const REEL_READY = 1;
export const REEL_PROCESSING = 2;

export const SHOW_ME_HOW_TEXT = 0;
export const SHOW_ME_HOW_CLIP = 1;
export const SHOW_ME_HOW_REEL = 2;

export const ACTIVE_TAB_ALL = 0;
export const ACTIVE_TAB_REELS = 1;
export const ACTIVE_TAB_CLIPS = 2;
export const ACTIVE_TAB_AREAS = 3;
export const ACTIVE_TAB_INSIGHTS = 4;
export const PINNED_CLIPS_TAB_ACTIVE = 0;
export const OPTION_DOWNLOAD_CLIP = "downloadClip";
export const OPTION_UNPIN_CLIP = "unpinClip";
export const OPTION_CREATE_NEW_HIGHLIGHT_REEL = "newHighlightReel";
export const OPTION_REMOVE_CLIP_FROM_REEL = "removeClipFromReel";

export const EXPANDABLE_TYPE_TEXT = 0;
export const EXPANDABLE_TYPE_TAG = 1;

export const MAX_LENGTH = {
  TEST_NAME: 40,
  THANK_YOU: 800,
  SURVEY_OPTIONS: 55,
  SURVEY_QUESTION: 220,
  WELCOME_MESSAGE: 400,
  TASK_DESCRIPTION: 1300,
};

export const MAX = { TASKS: 50, SURVEY_IMAGES: 10, SURVEY_IMAGE_SIZE: 2, TASK_IMAGE_SIZE: 5 }; // Image size is in the MB

export const YESNO = { NO: 0, YES: 1 };

export const INCLUDE_NDA = { OFF: 0, ON: 1 };

export const TRANSCRIPTION = { ENABLED: 1, DISABLED: 0 };

export const TRANSLATION_TOOL = { GOOGLE_TRANSLATE: 1, AI_TRANSLATE: 2, BATCH_TRANSLATE: 3 };

export const TRANSLATION_TYPE = { TRANSLATE: 0, SHORTEN: 1, REPHRASE: 2 };

export const DEVICE_TYPE = { COMPUTER: 1, TABLET: 2, MOBILE: 3, TABLET_AND_MOBILE: 4, TABLET_IPAD: 5, ANY: 6 };

export const INITIAL_TEST_TYPE = {
  DESIGN_PROTOTYPE_TEST: "design_prototype",
  MOBILE_APP_TEST: "mobile_app",
  WEBSITE_TEST: "website",
};

export const TEST_TYPE = {
  MODERATED: 0,
  WEBSITE: 1,
  ANDROID_APP: 2,
  ANDROID_SDK: 3,
  IOS_APP: 4,
  IOS_SDK: 5,
  MULTIOS_APP: 6,
  INSTANT_SESSION: 7,
};

export const TEST_TYPE_SURVEY = "survey";
export const TEST_TYPE_TASK = "task";
export const TEST_TYPE_MODERATED = "moderated";
export const TEST_TYPE_NORECORDING = "noRecording";
export const TEST_TYPE_CARDSORT = "cardsort";
export const TEST_TYPE_TREETEST = "treetest";

export const TEST_STATUS = {
  DRAFT: 0,
  ACTIVE: 2,
  DRYRUN: 4,
  HIDDEN: -1,
  INACTIVE: 1,
  REACTIVE: 11,
  COMPLETED: 3,
  UI_STATUS_COMPLETED: 31,
  UI_STATUS_TERMINATED: 32,
  UI_STATUS_EXPIRED: 33,
  EDIT_TEST: 8,
  SAVED_TEST: 7,
  PREVIEW_TEST: 9,
  TEMP_AB_TEST: -2,
  DELETE_SUFFIX: 6,
  COMPLETED_BY_USER: 5,
  SCREENER_FAILED_BY_USER: -3,
};

export const RECRUIT_OWN_TESTERS = "RECRUIT_OWN_TESTERS";
export const RECRUIT_PANEL_TESTERS = "RECRUIT_PANEL_TESTERS";

export const GENDER = { MALE: 0, FEMALE: 1, BOTH: -1 };

export const RECRUIT_AGE_LIMITS = { MIN: 18, MAX: 60 };
export const RECRUIT_NO_PARTICIPANT_ERR = "Please add atleast one participant before you launch the test.";
export const RECRUIT_SELF_SOURCED_INSUFFICEINT_ERR =
  "Insufficient platform credits. Please check back next month or upgrade your plan.";
export const ENTERPRISE_RECRUIT_SELF_SOURCED_INSUFFICEINT_ERR =
  "You are running out of credits. Please contact support team to top up your balance.";
export const RECRUIT_CREDITS_ERR = "Please ensure you have sufficient credits before you launch the test.";
export const ENTERPRISE_RECRUIT_CREDITS_ERR = "You are running out of credits. Please contact support team to top up your balance.";
export const PAID_RECRUIT_CREDITS_ERR = "Insufficient user panel credits.";
export const EXTRA_UA_CREDITS_ERR = "Please upgrade your plan.";
export const RECRUIT_DEMOGRAPHICS_ERR = "Please check your demographics criteria for errors.";

export const TASK_TYPES = {
  EMPTY: -1, // Only for UI (Empty Task)
  DEFAULT: 0, // Default Task (Website Navigation Task)
  BLANK: 1, // Blank Task (Speaking Task)
  IMAGE: 2, // Image Task
  EXTERNAL_PROTOTYPE: 3, // Figma/Marvel/Invision Task
  MOBAPP_PROTOTYPE: 4, // Mobile App Task
  SURVEY: 5, // Survey Task
  GROUP: 6, // Group Task
  FIVESEC: 7, // Five Second Task
  FIRSTCLICK: 8, // First Click Task
};

export const SURVEY_TYPES = {
  RADIO: "radio",
  TEXT: "textbox",
  RANKING: "ranking",
  CHECKBOX: "checkbox",
  LIKERT_5PT: "likert-scale-5pt",
  LIKERT_7PT: "likert-scale-7pt",
  LIKERT_10PT: "likert-scale-10pt",
};

export const TASK_TYPE_KEYS = {
  EMPTY_TASK: -1, // Only for UI (Empty Task)
  YESNO_QUESTION: 1,
  RATING_QUESTION: 2,
  OPEN_QUESTION: 3,
  RANK_OPTIONS: 4,
  MULTIPLE_TYPE: 5,
  WEBSITE_TYPE: 6,
  PROTOTYPE_TASK: 7,
  FIVESECOND_TASK: 8,
  IMAGE_TASK: 9,
  SPEAKING_TASK: 10,
  IOS_APP_TASK: 11,
  ANDROID_APP_TASK: 12,
  MULTIOS_APP_TASK: 13,
  FIVESEC_TASK: 14,
  FIRSTCLICK_TASK: 15,
};

export const ANSWER_TYPE = { TEXT: 1, NUMBER: 0 };
export const URL_PATTERN = { EXACT: 1, PARTIAL: 2, PATH_URLS: 3 };
export const LIKERT_TYPES = { SATISFACTION: 1, ENGAGEMENT: 2, NUMBERS: 3, CUSTOM: 4 };
export const SUCCESS_CRITERIA = { NONE: -1, ANSWER: 1, SUCCESS_URL: 2, GOAL: 3, TIME_COMPLETION: 4 };

export const SOURCE_INVISION = 0;
export const SOURCE_MARVEL = 1;
export const SOURCE_FIGMA = 2;
export const INTERACTING_TO_CHANGE_SCREEN = { NO_SCREEN: 0, START_SCREEN: 1, END_SCREEN: 2 };

export const PROTO_STATUS_IMPORTING = 0;
export const PROTO_STATUS_IMPORTED = 1;
export const PROTO_STATUS_ERROR = {
  PROTO_STATUS_ERR_TIMEOUT: { code: -1, message: "Timeout Error" },
  PROTO_STATUS_ERR_FIGMA_CURL: {
    code: -2,
    message: (
      <>
        Please set your Figma sharing permissions to <span className='fw-600'>"Anyone"</span> with{" "}
        <span className='fw-600'>"Can View"</span> access, then try again. <br />
        <br />
        <a
          target='_blank'
          rel='noreferrer'
          className='text-underline'
          href='https://help.uxarmy.com/space/UT/89620594/Common+Figma+Prototype+Issues'
        >
          Learn how to fix this
        </a>
      </>
    ),
  },
  PROTO_STATUS_ERR_FIGMA_NO_FRAMES: { code: -3, message: "Figma No Frames Error" },
  PROTO_STATUS_ERR_INVISION_CURL: { code: -4, message: "Invision viewing permissions not set to public" },
  PROTO_STATUS_ERR_INVISION_INVALID_URL: { code: -5, message: "Invision Invalid Url Error" },
  PROTO_STATUS_ERR_INVISION_NO_FRAMES: { code: -6, message: "Invision No Frames Error" },
  PROTO_STATUS_ERR_INVISION_NO_CONFIG: { code: -7, message: "Invision No Config Error" },
  PROTO_STATUS_ERR_MARVEL_CURL: { code: -8, message: "Marvel viewing permissions not set to public" },
  PROTO_STATUS_ERR_MARVEL_NO_FRAMES: { code: -9, message: "Marvel No Frames Error" },
  PROTO_STATUS_ERR_MARVEL_INVALID_URL: { code: -10, message: "Marvel Invalid Url Error" },
  PROTO_STATUS_ERR_GENERIC: { code: -11, message: "Generic Error" },
};

export const PREVIEW_PROGRESS = {
  SCREENER: "SCREENER",
  AVAILABLE_TEST: "AVAILABLE_TEST",
  NDA: "NDA",
  CONFIRMATION: "CONFIRMATION",
  TEST_DETAILS: "TEST_DETAILS",
  DEMOGRAPHICS: "DEMOGRAPHICS",
  TASK_DETAILS: "TASK_DETAILS",
  SUS_QUESTIONS: "SUS_QUESTIONS",
  TEST_SUBMIT: "TEST_SUBMIT",
  THANK_YOU: "THANK_YOU",
};

export const SUCCESS_TYPE = {
  NULL: -1, // No Criteria Match
  ANSWER: 1, // match with the user answer
  URL: 2, // match with the success urls
  GOAL: 3, // match with the goal
  TIME: 4, // match with the completion time
};

export const IS_REQUIRED = { YES: 1, NO: 0 };

export const IS_SURVEY_TASK = { YES: 1, NO: 0 };

export const USE_OTHER_OPTION = { YES: 1, NO: 0 };

export const DISCARD_CHANGES_PRESSED = "discard_changes_pressed";
export const UPDATE_PRESSED = "update_pressed";

export const SUBSCRIPTION_PLAN_ENTERPRISE = 3;

export const TEST_DEVICE_COMPUTER_ONLY = 1;
export const TEST_DEVICE_TABLET_ONLY = 2;
export const TEST_DEVICE_MOBILE_ONLY = 3;
export const TEST_DEVICE_TABLET_AND_MOBILE = 4;
export const TEST_DEVICE_TABLET_IPAD_ONLY = 5; // ipad only

// Comments
export const FILTER_COMMENTS_ITEMS = {
  SHOW_RESOLVED_COMMENTS: "Show resolved comments",
  ALL_COMMENTS: "All Comments",
  CURRENT_TASK: "Current Task",
  UNREAD: "Unread",
  LOW: "Low",
  HIGH: "High",
  CRITICAL: "Critical",
};

export const COMMENT_MAX_LENGTH = 6000;

export const COMMENT_ENTITY_TYPE_TASK = 0;
export const COMMENT_ENTITY_TYPE_SCREENER = 1;

export const COMMENT_PRIORITY_LOW = 0;
export const COMMENT_PRIORITY_HIGH = 1;
export const COMMENT_PRIORITY_CRITICAL = 2;

export const COMMENT_STATUS_UNRESOLVED = 0;
export const COMMENT_STATUS_RESOLVED = 1;

export const COMMENT_NOT_DELETED = 0;
export const COMMENT_DELETED = 1;

export const COMMENTS_PRIORITY = {
  LOW: { id: COMMENT_PRIORITY_LOW, label: "Low", color: "#F5A42E", bgColor: "#FEFFE1" },
  HIGH: { id: COMMENT_PRIORITY_HIGH, label: "High", color: "#9B51E0", bgColor: "#F7EDFF" },
  CRITICAL: { id: COMMENT_PRIORITY_CRITICAL, label: "Critical", color: "#EB5757", bgColor: "#FFE1E1" },
};

export const ALLOWED_NATIONALITY_QUOTA_TYPES = ["nationality"];

export const PRODUCTS = {
  MODERATED: "moderated",
  UNMODERATED: "unmoderated",
  CARDSORTING: "cardsorting",
  TREETESTING: "treetesting",
  SURVEYS: "surveys",
};

// TOOLBOX PLAN TYPES
export const TOOLBOX_PLAN_TYPES = { FREE: 0, MONTHLY: 1, YEARLY: 2, ENTERPRISES: 3 };

export const TEMPLATE_FILTER_SEARCH = "TEMPLATE_FILTER_SEARCH";
export const TEMPLATE_FILTER_USABILITY_TESTING_GOALS = "TEMPLATE_FILTER_USABILITY_TESTING_GOALS";
export const TEMPLATE_FILTER_INDUSTRIES = "TEMPLATE_FILTER_INDUSTRIES";
export const TEMPLATE_FILTER_TAGS = "TEMPLATE_FILTER_TAGS";
export const TEMPLATE_FILTER_DEVICE_TYPES = "TEMPLATE_FILTER_DEVICE_TYPES";
export const TEMPLATE_FILTER_TEST_TYPES = "TEMPLATE_FILTER_TEST_TYPES";

export const DEVICE_FRAME_IPHONE_13_MINI = "iphone_13_mini";
export const DEVICE_FRAME_IPHONE_14 = "iphone_14";
export const DEVICE_FRAME_ANDROID_SMALL = "android_small";
export const DEVICE_FRAME_ANDROID_LARGE = "android_large";
export const DEVICE_FRAME_PREVIEW = "preview";

export const SAFETY_AREA_OFF = "safety_area_off";
export const SAFETY_AREA_IPHONE = "safety_area_iphone";
export const SAFETY_AREA_ANDROID_LT_13 = "safety_area_android_lt_13";
export const SAFETY_AREA_ANDROID_13 = "safety_area_android_13";

export const DEVICE_FRAMES = [
  {
    key: DEVICE_FRAME_IPHONE_13_MINI,
    label: "iPhone 13 mini",
    dimensions: {
      width: 375,
      height: 812,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE],
  },
  {
    key: DEVICE_FRAME_IPHONE_14,
    label: "iPhone 14",
    dimensions: {
      width: 390,
      height: 844,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE],
  },
  {
    key: DEVICE_FRAME_ANDROID_SMALL,
    label: "Android (small)",
    dimensions: {
      width: 360,
      height: 640,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_ANDROID_LT_13, SAFETY_AREA_ANDROID_13],
  },
  {
    key: DEVICE_FRAME_ANDROID_LARGE,
    label: "Android (large)",
    dimensions: {
      width: 360,
      height: 800,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_ANDROID_LT_13, SAFETY_AREA_ANDROID_13],
  },
  {
    key: DEVICE_FRAME_PREVIEW,
    label: "Preview",
    dimensions: {
      width: "100%",
      height: "90vh",
      aspectRatio: "9/16",
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE, SAFETY_AREA_ANDROID_13],
  },
];

export const SAFETY_AREAS = [
  {
    key: SAFETY_AREA_OFF,
    label: "Off",
    topArea: {
      height: 0,
      asset: null,
    },
    bottomArea: {
      height: 0,
      asset: null,
    },
  },
  {
    key: SAFETY_AREA_IPHONE,
    label: "iPhone",
    topArea: {
      height: 44,
      asset: "iphone_top_safe_area",
    },
    bottomArea: {
      height: 32,
      asset: "iphone_bottom_safe_area",
    },
  },
  {
    key: SAFETY_AREA_ANDROID_LT_13,
    label: "Android < 13",
    topArea: {
      height: 24,
      asset: "android_lt_13_top_safe_area",
    },
    bottomArea: {
      height: 48,
      asset: "android_lt_13_bottom_safe_area",
    },
  },
  {
    key: SAFETY_AREA_ANDROID_13,
    label: "Android 13",
    topArea: {
      height: 24,
      asset: "android_13_top_safe_area",
    },
    bottomArea: {
      height: 48,
      asset: "android_13_bottom_safe_area",
    },
  },
];

export const TESTER_TYPE = { PANEL: "uxarmy", OWN: "random" };
export const GENDER_TYPE = { MALE: "M", FEMALE: "F", UNKNOWN: "U" };
export const TEST_COMPLETED = { NO: 0, YES: 1, RESET: 2, WITHOUT_VIDEO: 3 };
export const SESSION_RESULT = {
  NULL: 0,
  FAIL: 3, //if both successurl and answer dont match
  SUCCESS: 1, //if both successurl and answer match
  UNCLASSIFIED: 2, //if any one of successurl and answer dont match
  UNCLASSIFIED_WRNG_URL: 21,
  UNCLASSIFIED_WRNG_ANS: 22,
  DIRECT_SUCCESS: 4,
  INDIRECT_SUCCESS: 5,
};
export const SESSION_RESULT_TEXT = {
  [SESSION_RESULT.NULL]: "No Criteria",
  [SESSION_RESULT.FAIL]: "Fail",
  [SESSION_RESULT.SUCCESS]: "Success",
  [SESSION_RESULT.UNCLASSIFIED]: "UnClassified",
  [SESSION_RESULT.UNCLASSIFIED_WRNG_URL]: "UnClassified - Wrong URL",
  [SESSION_RESULT.UNCLASSIFIED_WRNG_ANS]: "UnClassified - Wrong Answer",
  [SESSION_RESULT.DIRECT_SUCCESS]: "Direct Success",
  [SESSION_RESULT.INDIRECT_SUCCESS]: "Indirect Success",
};

export const PATHS_COLOR_MAP = {
  [SESSION_RESULT.FAIL]: "#fa8ba6",
  [SESSION_RESULT.SUCCESS]: "#25a95f",
  [SESSION_RESULT.DIRECT_SUCCESS]: "#25a95f",
  [SESSION_RESULT.INDIRECT_SUCCESS]: "#C28800",
  [SESSION_RESULT.NULL]: "#2f62e9",
};

export const BROWSER_TEST_PROGRESS = {
  LANGUAGE_SELECTION: "LANGUAGE_SELECTION",
  SCREENER: "SCREENER",
  NDA: "NDA",
  DEMOGRAPHICS: "DEMOGRAPHICS",
  WELCOME: "WELCOME",
  TASKS: "TASKS",
  SUS: "SUS",
  UPLOADING: "UPLOADING",
  THANK_YOU: "THANK_YOU",
  EXIT: "EXIT",
};

export const FIGMA_TASK_NOT_STARTED = 0;
export const FIGMA_TASK_STARTED = 1;
export const FIGMA_TASK_PAUSED = 2;

export const MAX_TESTER_INVITES_REC_ON = 50;
export const MAX_TESTER_INVITES_REC_OFF = 100;

export const MODERATED_DEFAULT_DEBRIEFING_TIME = 15; // in minutes
export const MODERATED_SESSION_TYPE = { DEEPDIVE: "DEEPDIVE", EXTERNAL_UPLOADED: "EXTERNAL_UPLOADED" };

export const HEATMAP_EVENTS_TYPES = {
  CLICK: "c",
  HOVER: "m",
};

export const HEATMAP_TYPES = {
  CLICK_MAP: {
    id: "click_map",
    name: "Click Map",
    icon: "click_heatmap",
    tabIcon: "click_heatmap_icon",
    events: [HEATMAP_EVENTS_TYPES.CLICK],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.FIRSTCLICK },
    ],
  },
  HOVER_MAP: {
    id: "hover_map",
    name: "Hover Map",
    icon: "hover_heatmap",
    tabIcon: "hover_heatmap_icon",
    events: [HEATMAP_EVENTS_TYPES.HOVER],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE, excludedPrototypeSources: [SOURCE_FIGMA] },
    ],
  },
  MOUSE_MAP: {
    id: "mouse_map",
    name: "Mouse Map",
    icon: "mouse_map",
    tabIcon: "mouse_map_icon",
    events: [HEATMAP_EVENTS_TYPES.CLICK, HEATMAP_EVENTS_TYPES.HOVER],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE, excludedPrototypeSources: [SOURCE_FIGMA] },
    ],
  },
};

export const AI_SUMMARY_STATUS = { NOT_SENT: 0, PENDING: 1, COMPLETED: 2, NO_ENOUGH_DATA: 4, FAILED: 5 };
export const AI_SECTION_TYPES = { TEXT: "TEXT", VERBATIM: "VERBATIM", SUMMARY: "SUMMARY" };
export const SENTIMENT_TYPES = { POSITIVE: "POSITIVE", NEGATIVE: "NEGATIVE", NEUTRAL: "NEUTRAL" };
export const COMMON_DASHBOARD_TABS = {
  TEAMS_DASHBOARD: "TEAMS_DASHBOARD",
  PROJECTS_DASHBOARD: "PROJECTS_DASHBOARD",
  PLATFORM_SETTINGS_ORGANIZATION: "PLATFORM_SETTINGS_ORGANIZATION",
  WORKSPACES_SETTINGS: "WORKSPACES_SETTINGS",
  TEAMS_SETTINGS: "TEAMS_SETTINGS",
  MEMBERS_SETTINGS: "MEMBERS_SETTINGS",
  ACTIVITY_SETTINGS: "ACTIVITY_SETTINGS",
  CREDITS_SETTINGS: "CREDITS_SETTINGS",
  BILLING_SETTINGS: "BILLING_SETTINGS",
  EDIT_PROFILE: "EDIT_PROFILE",
};

export const USER_ROLES = {
  ADMIN: "admin",
  READ: "read",
  WRITE: "write",
  OWNER: "owner",
  COLLABORATOR: "collab",
};

export const USER_INVITE_STATUS = { ACCEPTED: "accepted", PENDING: "pending" };

export const INVITE_TYPE = {
  TEST: "test",
  PROJECT: "project",
  TEAM: "team",
  WORKSPACE: "workspace",
  ORGANIZATION: "organization",
};

// Toolkit Constants
export const TOOLKIT = {
  TEST_TYPES: { treetest: 0, participatorydesign: 1, cardsort: 2 },
};

export const PLANS = {
  FREE: "free",
  ESSENTIALS: "essentials",
  PRO: "pro",
  ENTERPRISE: "enterprise",
};

export const ACTIVITY_PAGE_SIZE = 5;

export const DEEPDIVE_ROLE_ICONS = {
  Observer: "glasses-02",
  Participant: "user-01",
  Translator: "translate",
  Moderator: "headphones",
  "Note Taker": "pencil-line",
  "Co-facilitator": "headphones",
};

export const DEEPDIVE_SESSION_MODE = {
  INDIVIDUAL: {
    key: 0,
    label: "1:1 Interview",
    image: INDIVIDUAL_ICON,
    desc: "only 1 participant to join",
    desc2: "Interview with a participant",
  },
  DYAD: { key: 1, label: "Dyad", image: DYAD_ICON, desc: "maximum 2 participants to join", desc2: "Interview with 2 participants" },
  TRIAD: {
    key: 2,
    label: "Triad",
    image: TRIAD_ICON,
    desc: "maximum 3 participants to join",
    desc2: "Triad, Interview with 3 participants",
  },
  FOCUS_GROUP: { key: 3, label: "Focus Group", image: FOCUS_GROUP_ICON, desc: "maximum 10 participants to join", desc2: "" },
};

// Toolkit Test Status
export const TOOLKIT_TEST_STATUS = { DRAFT: 0, ACTIVE: 1, INACTIVE: 2, EDIT: 3, COMPLETED: 4, DELETED: 5 };

export const INTEGRATIONS = { SLACK: 0, GOOGLE_SHEETS: 1 };

export const PLAN_FEE_TYPE = { FREE: 0, PAID: 1, MANUAL: 2 };
export const PLAN_RECURRING_TYPE = { MONTH: "month", YEAR: "year" };
export const ORGANIZATION_TEAM_SIZE = { SMALL_1: 1, SMALL_2_10: 2, MEDIUM_11_50: 3, MEDIUM_51_100: 4, LARGE_100_PLUS: 5 };

export const PURPOSE = {
  SUBSCRIPTION_START: 1,
  SUBSCRIPTION_RENEWAL: 2,
  TEST_CREATION: 3,
  TEST_PARTICIPATION: 4,
  BONUS: 5,
  ADMIN: 6,
  TOPUP: 7,
  REFUND: 10,
  SUBSCRIPTION_UPGRADE: 11,
  FREE_PLAN_ACTIVATED: 12,
};

export const INVITE_ERROR_CODES = {
  SUCCESS: "SUCCESS",
  INVALID: "INVALID",
  EXPIRED: "EXPIRED",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  ALREADY_MEMBER: "ALREADY_MEMBER",
  ALREADY_ACCEPTED: "ALREADY_ACCEPTED",
  MAX_INVITES_REACHED: "MAX_INVITES_REACHED",
  INVALID_RESOURCE_TYPE: "INVALID_RESOURCE_TYPE",
};
